import React from "react";
import { SearchPageComponent } from "./SearchPageComponent";

export const SearchPage: React.FC = () => {
  return <SearchPageComponent />;
};
